/**
 * Affiliate link configuration
 *
 * HOW TO ADD YOUR IDs:
 *
 * iVisa Partners  → https://partners.ivisa.com  (add &a_aid=YOUR_ID to iVisa URLs)
 * SafetyWing      → https://safetywing.com/affiliates  (add ?referral_code=YOUR_CODE)
 * World Nomads    → https://www.worldnomads.com/affiliates  (replace XXXXX below)
 * Skyscanner      → https://partners.skyscanner.net  (add &associateid=YOUR_ID)
 */

export const AFFILIATE = {
  /** Visa application service — contextual on visa-required / eVisa / on-arrival */
  ivisa: (destination: string) =>
    `https://www.ivisa.com/apply-visa?nationality=${destination}&a_aid=REPLACE_IVISA_ID`,

  /** Travel insurance — shown on all results */
  safetyWing: () =>
    `https://safetywing.com/nomad-insurance/?referral_code=REPLACE_SAFETYWING_CODE&utm_source=visahub&utm_medium=affiliate`,

  /** Travel insurance alternative */
  worldNomads: (destination: string) =>
    `https://www.worldnomads.com/travel-insurance/?utm_source=visahub&aff-id=REPLACE_WORLDNOMADS_ID&destination=${destination}`,

  /** Flight search deeplink */
  skyscanner: (origin: string, destination: string) =>
    `https://www.skyscanner.net/transport/flights/${origin}/${destination}/?&associateid=REPLACE_SKYSCANNER_ID`,
} as const;
